export default __webpack_public_path__ + "static/media/illustration-pin.2271c352.svg";